const SERVICING_ID_IDENTITY = 'servicingId'

export default SERVICING_ID_IDENTITY
